import { useEffect, useState } from "react";
import { get } from "./api";
export default function useStoreCategories() {
  const [categories, setCategories] = useState([]),
    [loading, setLoading] = useState(true),
    [error, setError] = useState("");
  useEffect(() => {
    let cancelled = false;
    get("/store-categories")
      .then((r) => {
        if (!cancelled) setCategories(r.categories || []);
      })
      .catch(() => {
        if (!cancelled) setError("Unable to load store categories.");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);
  return { categories, loading, error };
}
